var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPlacesdebout = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7.721,
    height: 18.271,
    viewBox: "0 0 7.721 18.271",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "places-debout",
    transform: "translate(-3684.14 -5914.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_218",
    "data-name": "Groupe 218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_10522",
    "data-name": 10522,
    transform: "translate(3684.14 5914.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_90",
    "data-name": "Groupe 90",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538,
    transform: "translate(2.293)",
    fill: "#5471a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_68",
    "data-name": "Trac\\xE9 68",
    d: "M19.826,11.056a2.8,2.8,0,0,0-1.176.014c-2.557.3-3.387,3.259-3.153,5.516.1.976,1.64.986,1.537,0a5.857,5.857,0,0,1,.388-2.945v3.216c0,.038,0,.073.005.11,0,.017-.005.032-.005.05,0,2.552,0,5.1-.11,7.653-.047,1.134,1.711,1.129,1.757,0,.083-2,.1-4,.108-6a2.033,2.033,0,0,0,.25,0c.005,2,.025,4,.107,6,.047,1.129,1.8,1.134,1.757,0-.105-2.55-.109-5.1-.109-7.653a.963.963,0,0,0-.027-.22c0-1.108-.045-2.217-.032-3.324a5.575,5.575,0,0,1,.48,3.114c-.1.985,1.435.975,1.537,0C23.382,14.282,22.512,11.246,19.826,11.056Z",
    transform: "translate(-15.459 -7.247)",
    fill: "#5471a9"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlacesdebout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/placesdebout.6237a37f.svg";
export { ForwardRef as ReactComponent };